"use client";

import { useMilestoneConsumedHours } from "components/milestone/stats/consumed/useMilestoneConsumedHours";
import { useMilestoneSpentHours } from "components/milestone/stats/spent/useMilestoneSpentHours";

// Combined hook for a single job
export function useMilestoneHours({id, name}) {

  const {
    data: consumed_hours,
    isLoading: comsumedLoading,
    error: consumedError,
  } = useMilestoneConsumedHours(id);
  const {
    data: spent_hours,
    isLoading: spentLoading,
    error: spentError,
  } = useMilestoneSpentHours(id);

  return {
    data: {
      name: name,
      consumed_hours: consumed_hours || 0,
      spent_hours: spent_hours || 0,
    },
    loading: comsumedLoading || spentLoading,
    error: consumedError || spentError,
  };
}
